module.exports = __webpack_public_path__ + "img/loveSeries.507993c6.png";